module.exports = __webpack_public_path__ + "static/media/careers-page-grid3.73d66c2b.png";